export enum LoginType {
    VTSSW = 'VTSSW',
    SMARTCARD = 'SMARTCARD',
    TOKEN = 'TOKEN',
    MOCK = 'MOCK',
    BYPASS = 'BYPASS',
    EMERGENCY = 'EMERGENCY'
}

export interface LoginOption {
    type: LoginType;
    imageSrc: string;
    altText: string;
}

export enum Auth {
    TOKEN = "idToken",
    REFRESH_TOKEN = "refreshToken",
}

export enum AuthQueryParam {
    AUTHORIZATION_CODE = "authorization-code"
}

export enum AuthErrorCode {
    USER_NOT_FOUND = "USER_NOT_FOUND"
}